export interface RecipeMenuDiary {
  RecipeMenuDiaryId: string;
  CustomerId: string;
  RecipeMenuHeaderId: string;
  ActionType: number;
  ActionSummary: string;
  AdditionalData: string;
  ChangeByUser: string;
  CreateDate: Date | string;
  ChangeDate: Date | string;
  DeleteDate?: Date | string;
  CanRevert: boolean;
}

export type GetRecipeMenuDiariesRequest = {
  CustomerId: string;
  RecipeMenuHeaderId?: string;
  ActionType?: number;
  StartDate: Date | string;
  EndDate: Date | string;
};

export type RevertRecipeMenuDiaryActionRequest = {
  RecipeMenuDiaryId: string;
};

export enum RecipeMenuDiaryActionType {
  RecipeMenuHeader_Add = 0,
  RecipeMenuHeader_Update = 1,
  RecipeMenuHeader_Remove = 2,

  RecipeMenuDetail_Add = 3,
  RecipeMenuDetail_Update = 4,
  RecipeMenuDetail_Remove = 5,

  RecipeMenuHeaderPrivateUser_Add = 6,
  RecipeMenuHeaderPrivateUser_Remove = 7,

  RecipeMenuHeader_Recover = 8,
}
